import {UserService} from './typescript-angular-client-generated';
import {Injectable} from '@angular/core';

@Injectable()
export class UserServiceEx extends UserService
{
  protected basePath = '';

  setBasePath(basePath: string)
  {
    this.basePath = basePath;
  }
}
